import React, { useEffect } from "react";
import { connect, ConnectedProps } from "react-redux";
import {
  Route,
  RouteComponentProps,
  Switch,
  withRouter,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";

import { setSelected } from "@/reducers/groupReducer/groupThunks";
import { getUserInfor } from "@/reducers/mrgReducer/mrgThunks";

import LoaderModal from "./General/LoaderModal/LoaderModal";
import LoginApp from "./LoginFlow/LoginApp";
import MainFlowApp from "./MainFlow/MainFlowApp";

import "react-toastify/dist/ReactToastify.min.css";
import useIntercom from "@/hooks/useIntercom";

const initWindowSize = () => {
  const vh = window.innerHeight;
  const vw = window.innerWidth;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
  document.documentElement.style.setProperty("--vw", `${vw}px`);
};

type Props = RouteComponentProps;

type ReduxProps = ConnectedProps<typeof connector>;

const App: React.FC<Props & ReduxProps> = ({
  history,
  getUserInfor,
  setSelected,
  mrg,
}) => {
  useEffect(() => {
    initWindowSize();
    window.addEventListener("resize", initWindowSize);
    window.addEventListener("orientationchange", initWindowSize);

    if (window.location.href.indexOf("merchant") === -1) {
      history.push("/");
    }

    return () => {
      window.removeEventListener("resize", initWindowSize);
      window.removeEventListener("orientationchange", initWindowSize);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getUserInfor()
      .then(() => {
        const pathname = history.location.pathname;
        history.push(
          `${pathname === "/login" ? "/" : pathname}${window.location.search}`
        );
      })
      .catch(() => {
        setSelected(false);
        history.push(`/login${window.location.search}`);
      });
  }, []);

  useIntercom(mrg.email, mrg.name);

  return (
    <React.Fragment>
      <ToastContainer position={"top-center"} newestOnTop />
      <LoaderModal />
      <Switch>
        <Route component={LoginApp} path={`/login`} />
        <Route component={MainFlowApp} path={"/"} />
      </Switch>
    </React.Fragment>
  );
};

const mapStateToProps = (state: RootState) => ({
  mrg: state.mrg,
});

const mapDispatchToProps = {
  getUserInfor,
  setSelected,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(withRouter(App));
